import React from 'react'
import { FaLinkedin, FaGithub, FaTwitter,  FaInstagram } from 'react-icons/fa'

const HeaderSocials = () => {
  return (
      <div className='header_socials'>
          <a href="https://www.linkedin.com/in/desh-deepak-kushwaha-b65929254/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          <a href="https://github.com/DeshDeepakKushwaha" target="_blank" rel="noreferrer"><FaGithub /></a>
          <a href="https://twitter.com/deepu4477?t=5PkHBRFDruPI4wtj3mIk7Q&s=08" target="_blank" rel="noreferrer"><FaTwitter /></a>
           <a href="https://www.instagram.com/deepu_4477/?igshid=NTA5ZTk1NTc%3Ds" target="_blank" rel="noreferrer"><FaInstagram /></a>
    </div>
  )
}

export default HeaderSocials